import Board from './_Board'

export default Board
